import { RootState } from '../../store/store';

export const selectResult = (state: RootState) => state.scheduledJob.result;
export const selectLoading = (state: RootState) => state.scheduledJob.loading;
export const selectError = (state: RootState) => state.scheduledJob.error;
export const selectErrorMessage = (state: RootState) => state.scheduledJob.errorMessage;
export const selectTriggered = (state: RootState) => state.scheduledJob.triggered;
